<template>
    <div class="text-left">

        <div class="alert alert-success" v-if="copied">
            Link copied, please issue this to the person you want to invite, or use "send invite" for an automatic email to be sent
        </div>
        <copy-to-clipboard
            label="copy-invite"
            :text-to-copy="participant.prepay_invite_link"
            @copied="onCopy"
        ></copy-to-clipboard>

        <b-form-input class="mb-1" placeholder="Participants email" v-validate="'email|required'" data-vv-scope="invite"
                      type="email" data-vv-as="email address" name="email" v-model="email"/>
        <div v-show="vErrors.has('invite.email')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.email') }}
        </div>

        <b-form-input class="mb-1" placeholder="Participants first name" v-validate="'required'" data-vv-scope="invite"
                      name="firstName" data-vv-as="first name" type="text"
                      v-model="firstName"/>
        <div v-show="vErrors.has('invite.firstName')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.firstName') }}
        </div>

        <b-form-input class="mb-1" placeholder="Participants last name" v-validate="'required'" data-vv-scope="invite"
                      name="lastName" data-vv-as="last name" type="text" v-model="lastName"/>
        <div v-show="vErrors.has('invite.lastName')"
             class="text-danger mb-2">
            {{ vErrors.first('invite.lastName') }}
        </div>

        <b-form-textarea
                id="textarea"
                max-rows="6"
                placeholder="Customised message"
                rows="3"
                v-model="message"/>

        <b-button :class="btnClass" @click="sendInvite" block class="mt-2"
                  :variant="btn ? 'outline-primary' : 'success'"
                  :disabled="!btn || submitting">{{ btnText }}
        </b-button>
    </div>
</template>

<script>
    import axios from 'axios'
    import CopyToClipboard from "../Utility/Buttons/CopyToClipboard.vue";

    export default {
        name: "PrePayInviter",
        props: {
            participant: {
                type: Object,
                required: true,
            }
        },
        components: {
            CopyToClipboard,
        },
        computed: {
            btnClass() {
                if (this.btn) {
                    return "btn-primary";
                }
                return "btn-success";
            },
            btnText() {
                if(this.submitting){
                    return "Sending Invite.. Please Wait";
                }

                return this.btn ?  'Send Invite' : 'Invite sent!';
            }
        },
        data() {
            return {
                email: '',
                firstName: '',
                lastName: '',
                message: '',
                btn: true, //If the button can be pressed,
                submitting: false,
                copied: false,
            }
        },
        created() {
            this.email = this.participant.email || '';
            this.firstName = this.participant.first_name || '';
            this.lastName = this.participant.last_name || '';
        },
        methods: {
            sendInvite() {

                this.submitting = true;
                this.$validator.validateAll('invite').then((result) => {

                    if (result) {

                        axios
                            .post(`/api/v0/participants/${this.participant.id}/prepay/invite`, {
                                email: this.email,
                                first_name: this.firstName,
                                last_name: this.lastName,
                                message: this.message,
                            })
                            .then(() => {
                                this.btn = false;
                                this.$root.$emit('bv::hide::modal', 'inviteModal' + this.participant.id);
                                window.location.reload(true);
                            }).catch((e) => {
                            this.submitting = false;
                        });
                    } else {
                        this.submitting = false;
                    }

                });
            },
            onCopy() {
                this.copied = true;
                setInterval(() => {
                    // this.$root.$emit('bv::hide::modal', 'teamInviteModal')
                    this.copied = false;
                }, 4000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/PrePayInviter.vue